import { UserService } from '../../provider/user.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuConfig {
  public admin: HeaderMenuModel[] = [
    {
      title: 'Home',
      page: '/home',
      items: []
    },
    {
      title: 'Users',
      page: '/users',
      items: [
        {
          title: 'Hotels',
          icon: 'fas fa-list',
          page: '/users'
        },
        {
          title: 'User List',
          icon: 'flaticon2-browser-2',
          page: '/users/admins'
        },
        {
          title: 'Add User',
          icon: 'flaticon2-browser-2',
          page: '/users/add-user/0'
        }
      ]
    },
    {
      title: 'Analysis',
      page: '/analysis',
      items: [
        {
          title: 'Tables',
          icon: 'flaticon2-browser-2',
          page: '/analysis'
        }
      ]
    }

  ];
  public hoteladmin: HeaderMenuModel[] = [
    {
      title: 'Home',
      page: '/home',
      items: []
    },
    // {
    //   title: 'Users',
    //   page: '/users',
    //   items: [
    //     {
    //       title: 'List User',
    //       icon: 'flaticon2-browser-2',
    //       page: '/users'
    //     },
    //     {
    //       title: 'Add User',
    //       icon: 'flaticon2-browser-2',
    //       page: '/users/add-user/0'
    //     }
    //   ]
    // },
    {
      title: 'Analysis',
      page: '/analysis',
      items: [
        {
          title: 'Item Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/item-analysis'
        },
        {
          title: 'Personel Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/personel-analysis'
        },
        {
          title: 'Guest Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/guest-analysis'
        },
        // {
        //   title: 'Products Analysis',
        //   icon: 'flaticon2-browser-2',
        //   page: '/analysis/products-analysis'
        // },
        {
          title: 'Item Based Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/item-based-analysis'
        },
        {
          title: 'Worker Performance Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/worker-performance-analysis'
        },
        {
          title: 'Locale Based Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/locale-analysis'
        },
        {
          title: 'Group Hotels Analysis',
          icon: 'flaticon2-browser-2',
          page: '/analysis/group-hotels-analysis'
        },
        {
          title: 'Tables',
          icon: 'flaticon2-browser-2',
          page: '/analysis/tables'
        }
      ]
    }
  ];
  public user: HeaderMenuModel[] = [
    {
      title: 'Home',
      page: '/home',
      items: []
    }
  ];

  manager: HeaderMenuModel[] = [
    {
      title: 'Home',
      page: '/home',
      items: []
    },
    {
      title: 'Analysis',
      page: '/analysis',
      items: [
        {
          title: 'Tables',
          icon: 'flaticon2-browser-2',
          page: '/analysis'
        }
      ]
    }

  ];

  headerMenuChange$ = new BehaviorSubject<HeaderMenuModel[] | undefined>(undefined);

  constructor(private userService: UserService) {
    this.configs();
  }

  configs() {
    this.userService.getMe();
    this.userService.record_change$.subscribe(
      (user) => {
        if (user != undefined) {
          switch (user.role) {
            case 'admin':
              this.headerMenuChange$.next(this.admin);
              break;
            case 'hoteladmin':
              this.headerMenuChange$.next(this.hoteladmin);
              break;
            case 'user':
              this.headerMenuChange$.next(this.user);
              break;
            case 'manager':
              this.headerMenuChange$.next(this.manager);
              break;
            default:
              this.headerMenuChange$.next(this.user);
              break;
          }
        }
      }
    );

  }
}

export class HeaderMenuModel {
  title: string;
  page: string;
  items: AsideMenuModel[];

  constructor(
    title = '',
    page = '',
    items = []
  ) {
    this.title = title;
    this.page = page;
    this.items = items;
  }
}

export class AsideMenuModel {
  title: string;
  icon: string;
  page: string;
  submenu?: SubMenuModel[];
  root?: boolean;

  constructor(
    title = '',
    icon = '',
    page = '',
    submenu = [],
    root = true
  ) {
    this.title = title;
    this.icon = icon;
    this.page = page;
    this.submenu = submenu;
    this.root = root;
  }
}

export class SubMenuModel {
  title: string;
  page: string;
  show: boolean;

  constructor(
    title = '',
    page = '',
    show = true
  ) {
    this.title = title;
    this.page = page;
    this.show = show;

  }
}
